import {Component, OnInit, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-onboarding-privacy-modal',
  templateUrl: './onboarding-privacy-modal.component.html',
  styleUrls: ['./onboarding-privacy-modal.component.scss']
})
export class OnboardingPrivacyModalComponent implements OnInit {
  @Output() displayEvent = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit(): void {
  }
  closeModal(){
    this.displayEvent.emit (false);
  }

}
